import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, ArrowsLeftRight, ChartPieSlice, Drop, IdentificationCard, SealCheck, Table, Vault } from "@phosphor-icons/react";

const TABS = [
  { to: "/viveka-kartha/wealth", label: "Overview", icon: Vault },
  { to: "/viveka-kartha/wealth/profile", label: "Family profile", icon: IdentificationCard },
  { to: "/viveka-kartha/wealth/register", label: "Asset & liability register", icon: Table },
  { to: "/viveka-kartha/wealth/allocator", label: "Wealth allocator", icon: ChartPieSlice },
  { to: "/viveka-kartha/wealth/liquidity", label: "Liquidity & balance sheet", icon: Drop },
  { to: "/viveka-kartha/wealth/bridge", label: "Business to family bridge", icon: ArrowsLeftRight },
  { to: "/viveka-kartha/wealth/positions", label: "Board positions & handout", icon: SealCheck },
];

export const WealthShell = ({ title, description, children, actions }) => {
  const { pathname } = useLocation();
  return (
    <div className="space-y-7" data-testid="vk-wealth-shell">
      <Link to="/viveka-kartha" data-testid="wealth-back"
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.16em] text-navy hover:text-plum">
        <span className="grid h-7 w-7 place-items-center rounded-full bg-navy text-white"><ArrowLeft size={13} /></span>
        Back to Viveka Kartha
      </Link>

      <div className="panel overflow-hidden">
        <div className="brand-bar h-1.5 w-full" />
        <div className="flex flex-col gap-5 p-6 md:flex-row md:items-center md:justify-between md:p-8">
          <div className="flex items-start gap-5">
            <div className="grid h-14 w-14 shrink-0 place-items-center rounded-full bg-plum text-white">
              <Vault size={26} />
            </div>
            <div>
              <p className="label-caps">Viveka Kartha · Wealth allocation</p>
              <h1 className="font-display text-3xl tracking-tight text-navy">{title}</h1>
              {description && <p className="mt-1 max-w-2xl text-sm text-foreground/75">{description}</p>}
            </div>
          </div>
          {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </div>
        <div className="flex flex-wrap gap-2 border-t border-border px-6 py-4 md:px-8">
          {TABS.map((t) => {
            const active = pathname === t.to;
            return (
              <Link key={t.to} to={t.to} data-testid={`wealth-tab-${t.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-[10px] uppercase tracking-[0.14em] transition-colors ${
                      active ? "bg-plum text-white" : "border border-border text-navy hover:border-plum/50"}`}>
                <t.icon size={14} /> {t.label}
              </Link>
            );
          })}
        </div>
      </div>

      {children}
    </div>
  );
};
